module.exports = __webpack_public_path__ + "img/repara.4afeafb1.jpg";